<template>
  <div class="discovery-discovery-view">
    <search-results :search="search"></search-results>
  </div>
</template>

<script>
import SearchResults from '@/components/views/SearchResults.vue';

export default {
  name: 'DiscoveryView',
  components: {
    SearchResults,
  },
  data() {
    return {
      search: {
        state: 'init',
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="less">

</style>
